export const ALL = 'ALL';
export const NOT_PROCESSED = 'NOT_PROCESSED';
export const PROCESSED = 'PROCESSED';
export const PURCHASE = 'purchase';
export const SALE = 'sale';
export const POS_SALE = 'posSale';
